@if (showQuestionnaire && questionnaire) {
  @for (category of questionnaire.questionCategories; track category) {
	<div class="category" [prefixIcon]="showCategoryDetails ? getCategoryIcon(category) : ''">
	  @if (showCategoryDetails) {
		<div class="text-bold-3">{{ 'questionnaire.category.' + categoryType[category.categoryType] | translate }}</div>
	  }
	  @for (group of category.questionGroups; track group.id) {
		@if (showCategoryDetails && category.categoryType === categoryType.Company && group.company) {
		  <div class="information-container"><ng-container *ngTemplateOutlet="companyDetails; context:{ company: group.company }" /></div>
		}
		@if (showCategoryDetails && category.categoryType === categoryType.Order && group.orderId) {
		  <div class="information-container"><order-lines [orderLines]="orders.get(group.orderId)?.orderLines ?? []" /></div>
		}
		@if (category.categoryType === categoryType.Product) {
		  <h3>{{ group.variantName }}</h3>
		}
		@for (question of group.questions; track question) {
		  <questionnaire-question [question]="question" [displayAsForm]="displayAsForm" [editable]="editable" />
		}
	  }
	</div>
  }
}

@if (!questionnaireLoaded) {
  <skeleton height="25px" />
  <div class="category">
	<div class="display-mode">
	  @for (i of [1,2,3]; track i) {
		<div class="question">
		  <data-table>
			<data-row>
			  <skeleton />
			  <skeleton width="50%" />
			</data-row>
		  </data-table>
		</div>
	  }
	</div>
  </div>
}

<ng-template #companyDetails let-company="company">
  <div>{{ company.name }}</div>
  <div>{{ company.address }}</div>
  <div>{{ company.zipcode }} {{ company.city }}</div><br />
  @if (company.primaryContact?.role) {
	<div>{{ company.primaryContact?.role }}</div>
  }
  <div>{{ company.primaryContact?.fullName }}</div>
  <div>{{ 'general.phone' | translate }} {{ company.primaryContact?.contactPhones?.[0]?.number }}</div>
  <div>{{ company.primaryContact?.emailAddress }}</div>
</ng-template>
